import { Link, useNavigate } from "react-router-dom";

export default function InnerHeader({name,linkP,linkS,root=false}:any){
   const navigate = useNavigate();
   return(
        <header className="row px-2 py-0 my-4 align-items-center rounded border shadow">   
            <div className="col m-0 p-3">
                {root ? 
                    <Link to={root} className="d-inline btn btn-secondary btn-md me-2"><span className="zmdi zmdi-chevron-right zmdi-hc-lg"></span> </Link> :
                    <button onClick={() => navigate(-1)} className="d-inline btn btn-secondary btn-md me-2"><span className="zmdi zmdi-chevron-right zmdi-hc-lg"></span> </button>
                }
                <h5 className="d-inline fw-bold">{name}</h5>
            </div>

            {(linkP || linkS) && <div className="col col-md-3">
                <div className="row justify-content-end">
                    <div className="btn-group" role="group" aria-label="header buttons">
                        {linkP && <Link to={linkP.url} className="btn btn-outline-primary">{linkP.name}</Link>}
                        {linkS && <Link to={linkS.url} className="btn btn-outline-success">{linkS.name}</Link>}
                    </div>
                </div>
            </div>}
        </header>
   )
}